<button [id]="id" [disabled]="disabled" [type]="type" [style.background-color]="backgroundColor">
	<img *ngIf="iconUri else text" alt="button-icon" [src]="iconUri">
	<ng-template #text>
		<div class="button-text"><ng-content></ng-content></div>
	</ng-template>
</button>
<ng-container *ngIf="type === 'file'">
	<input #file type="file" [accept]="accept" (change)="fileSelect.emit($event.target['files'][0])">
</ng-container>
